import { render, staticRenderFns } from "./RequestFieldBadge.vue?vue&type=template&id=ed34acd8&"
import script from "./RequestFieldBadge.ts?vue&type=script&lang=ts&"
export * from "./RequestFieldBadge.ts?vue&type=script&lang=ts&"
import style0 from "./RequestFieldBadge.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VChip,VTooltip})
